import React, { FC, ReactNode } from 'react';

import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

export const SummaryLabel: FC<{ children: ReactNode }> = ({ children }) => (
  <Box color={customTheme.colors.gray['250']}>{children}</Box>
);
